module.exports = __webpack_public_path__ + "static/dusanstvo_landing-e2134f0e40fc1b60014da41a8bfa1231.jpg";